import {call, put} from "redux-saga/effects";
import axios from "axios";
import {BASE_URL, MAIN_POST, STORES_GET} from "../../apis";
import * as types from "../types/stores.types";
import {actionLogOutUser} from "../actions/user/user";
import _ from "lodash";
import {actionChangeDataShoppingCart} from "../actions/shoppingCart";
import qs from "querystring";
import {handelChangeMainSite, handleChangeDataMainSite} from "../actions/main/main";
import {toast} from "react-toastify";
import {actionChangeStatusProgressBar} from "../actions";

export function* fetchStores({payload: {token, activeAddress, guestAddress, storeSelected}}) {
    try {
        yield put(actionChangeStatusProgressBar(true));
        const payload_url = {token, activeAddress, guestAddress};
        const response = yield call(axios, urlStores(BASE_URL + STORES_GET, payload_url));
        const {status} = response.data;
        if (status === 'ok') {
            const {stores, banners} = response.data;
            yield put({type: types.STORES_AND_BRAND_RESULT, payload: {stores, banners}});
            if (storeSelected && !_.find(stores, store => store.id === storeSelected.id)) {
                yield put(actionChangeDataShoppingCart('storeSelected', null));
                yield put(actionChangeDataShoppingCart('carts', []));
            }
        } else if (status === "re_login") {
            yield  put(actionLogOutUser());
        }
    } catch (e) {
        console.log(e);
    } finally {
        yield put(actionChangeStatusProgressBar(false));
    }
}

const urlStores = (url, payload) => {
    const {token, activeAddress, guestAddress} = payload;
    let dataUrl = '';
    if (token) {
        const {glat, glng, addressId} = activeAddress;
        dataUrl = `?glat=${glat}&glng=${glng}&address=${addressId}`;

    } else if (guestAddress.lat !== 0 && guestAddress.lng !== 0) {

        const {lat, lng} = guestAddress;
        dataUrl = `?glat=${lat}&glng=${lng}`;

    } else {
        dataUrl = '';
    }
    return url + dataUrl;
}

export function* fetchMainStore({payload: {store}}) {
    try {
        yield put(handleChangeDataMainSite('loader_main', true));
        yield put(actionChangeStatusProgressBar(true));
        const data = qs.stringify({store, platform: 'web'});
        const response = yield call(axios.post, BASE_URL + MAIN_POST, data);
        const {status} = response.data;
        if (status === 'ok') {
            yield put(handelChangeMainSite(response.data));
        } else if (status === 'error') {
            toast.error(response.data.message);
        }
    } catch (e) {
        console.log(e);
    } finally {
        yield put(handleChangeDataMainSite('loader_main', false));
        yield put(actionChangeStatusProgressBar(false));
    }
}